import axios from 'axios';
import { handleError } from '../utils/error';
const API_URL = process.env.NOTIFICATIONS_API_URL;
/*
  CREATE
*/
export const sendNotification = async ({ itemNumber, shortMessage, emailMessage, token }) => {
    try {
        const response = await axios.post(`${API_URL}/broadcast`, {
            itemNumber,
            shortMessage,
            emailMessage
        }, { headers: { Authorization: `Bearer ${token}` } });
        return response.data;
    }
    catch (error) {
        handleError('sendNotification', error);
        return error.response;
    }
};
/*
  READ
*/
export const getNotificationsEnabled = async (itemNumber) => {
    try {
        const response = await axios.get(`${API_URL}/product/${itemNumber}/features/notifications`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('authToken')}`
            }
        });
        return response;
    }
    catch (error) {
        handleError('getNotificationsEnabled', error);
        return error.response;
    }
};
export const getBroadcastsByItemNumber = async ({ token, itemNumber }) => {
    try {
        const response = await axios.get(`${API_URL}/broadcast?itemNumber=${itemNumber}`, { headers: { Authorization: `Bearer ${token}` } });
        return response;
    }
    catch (error) {
        handleError('getBroadcastsByItemNumber', error);
        return error.response;
    }
};
/*
  UPDATE
*/
/*
  DELETE
*/
/*
  UNSORTED
*/
//# sourceMappingURL=Notifications.js.map